import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  bulkCreateProjectPositionWorkflowSteps,
  deleteProjectPositionWorkflowStep
} from '../../../api/project-position-workflow-steps';
import { ProjectPosition } from '../ProjectPosition/projectPositionSlice';

export interface ProjectPositionWorkflowStep {
  id: number;
  projectPositionId: number;
  projectPosition: ProjectPosition;
}

export const bulkCreateProjectPositionWorkflowStepsAsync = createAsyncThunk(
  'projectPositionWorkflowSteps/bulkCreateProjectPositionWorkflowSteps',
  bulkCreateProjectPositionWorkflowSteps
);

export const deleteProjectPositionWorkflowStepAsync = createAsyncThunk(
  'projectPositionWorkflowSteps/deleteProjectPositionWorkflowStep',
  deleteProjectPositionWorkflowStep
);
